import { render } from "./Faq.vue?vue&type=template&id=69207c05&scoped=true&lang=html"
import script from "./Faq.vue?vue&type=script&setup=true&lang=js"
export * from "./Faq.vue?vue&type=script&setup=true&lang=js"

import "./Faq.vue?vue&type=style&index=0&id=69207c05&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69207c05"]])

export default __exports__